/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
    export class Ajuda {
        public static inicializar() {
            var ajuda = new App.Ajuda();
            ajuda.inicializarEventos();
        }
    }
}

namespace App {
    export class Ajuda {

        public inicializarEventos() {
        }
    }
}
